// extracted by mini-css-extract-plugin
module.exports = {"root":"ListTabs_root__1MVKb","tab":"ListTabs_tab__2hVP_","--active":"ListTabs_--active__1-HTC"};